export const addQueryParamTimeToEscapeCash = imgSrc => {
  const url = new URL(imgSrc);
  url.searchParams.set('t', `${new Date().getTime()}`);
  return url.href;
};
